import { FaHome, FaBriefcase, FaUsers, FaRegQuestionCircle, FaAward } from "react-icons/fa";
import './styles.scss';

const timeline = [
  {
    year: "1995",
    icon: <FaHome size={26} />,
    text: "Fundação da Séculos em Belém.",
  },
  {
    year: "2000",
    icon: <FaBriefcase size={26} />,
    text: "Transferência da sede para Parauapebas.",
  },
  {
    year: "2020",
    icon: <FaUsers size={26} />,
    text: "Alteração do quadro societário da empresa.",
  },
  {
    year: "2022",
    icon: <FaRegQuestionCircle size={26} />,
    text: "Adequação da identidade visual para refletir novos valores.",
  },
  {
    year: "2023",
    icon: <FaAward size={26} />,
    text: (
      <>
        <p>Certificação da Qualidade (ISO).</p>
        <p>Inauguração da nova sede.</p>
        <p>Solidificação na área de engenharia com projetos estratégicos.</p>
      </>
    ),
  },
];

export default function CronologiaSeculos() {
  return (
    <section id="cronologia" className="home">
      <div className="container line-box">
        <div className="box-about">
          <div className="box-title">
            <h3
              data-aos="fade-zoom-in"
              data-aos-duration="1000"
              data-aos-delay="300"
              data-aos-offse="0"
            >
              Cronologia Séculos
            </h3>
          </div>
          <div className="timeline">
            {timeline.map((item, index) => (
              <div
                key={index}
                className="timeline-item"
                data-aos="fade-up"
                data-aos-duration="800"
                data-aos-delay={index * 200}
              >
                <div className="timeline-icon">{item.icon}</div>
                <div className="timeline-year">{item.year}</div>
                <div className="timeline-text">{item.text}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
